import React from 'react';
import { Tooltip } from '@michelin/acid-components';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import { useTranslation } from '@michelin/central-provider';

const POSInfoIcon = () => {
    const { t } = useTranslation();
    
    return (
        <Tooltip
            placement="top-end"
            title={(
                <div style={{ fontSize: 12 }}>
                {t('This value is integrated with your POS and is set by your B2B profile')}
                </div>
            )}
            >
            <InfoOutlined fontSize="small" style={{ cursor: 'pointer', position: 'absolute', right: '10px' }} />
        </Tooltip>
    );
}

export default POSInfoIcon;